<template>
    <div v-if="quick_album&&quick_album.images.length>0">
        <div v-if="quick_album.type==ALBUM_TILE">
            <img v-for="image in quick_album.images" :key="image.id" class="picture" :src='$common.HOST+"/resources/"+image.filename' />
        </div>
        <div v-if="quick_album.type==ALBUM_TILE_MARGIN">
            <img v-for="image in quick_album.images" :key="image.id" class="picture-margin" :src='$common.HOST+"/resources/"+image.filename' />
        </div>
        <div v-if="quick_album.type==ALBUM_SLIDE">
            <Carousel :value="quick_album.images" :num-visible="1" :num-scroll="1" :autoplay-interval="3000" :circular="true" :show-navigators="false">
                <template #item="image">
                    <img class="picture" :src='$common.HOST+"/resources/"+image.data.filename' />
                </template>
            </Carousel>
        </div>
        <div v-if="quick_album.type==ALBUM_GALLERIA">
            <Galleria :value="quick_album.images">
                <template #item="image">
                    <img class="picture" :src='$common.HOST+"/resources/"+image.item.filename' />
                </template>
                <template #thumbnail="image">
                    <div class="grid grid-nogutter justify-content-center">
                        <img style="width:50%" :src='$common.HOST+"/resources/"+image.item.filename' />
                    </div>
                </template>
            </Galleria>
        </div>
    </div>
</template>

<script>
import Carousel from 'primevue/carousel';
import Galleria from 'primevue/galleria';

export default {
  name: 'QuickAlbum',
  components: {
    Carousel,
    Galleria
  },
  data(){
    return {
        ALBUM_TILE:1,
        ALBUM_TILE_MARGIN:2,
        ALBUM_SLIDE:3,
        ALBUM_GALLERIA:4
    }
  },
  props: {
    quick_album: null
  },
  methods:{
    
  },
  created(){
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.picture{
    width: 100%;
    display: block;
}
.picture-margin{
    width: 100%;
    margin-bottom: 10px;
    display: block;

}
.picture-margin:last-child{
    margin-bottom: 0px;
}
.justify-content-center {
    justify-content: center!important;
}
.grid-nogutter {
    margin-right: 0;
    margin-left: 0;
    margin-top: 0;
}
.grid {
    display: flex;
    flex-wrap: wrap;
    margin-right: -1rem;
    margin-left: -1rem;
    margin-top: -1rem;
}
</style>